import React, {Component} from 'react';
import {Button} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import DataFormat from "../../../../utilities/DateAndTimeFormat";
import PokazRozkladPrzystankiTable from "../../../konfiguracja/rozkladConfig/rozklad/pokazRozklad/components/PokazRozkladPrzystankiTable";
import RozkladService from "../../../konfiguracja/rozkladConfig/rozklad/RozkladService";
import tabgrid from "../../../../utilities/TabGrid";

export default class UrzadRozkladTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded_content: [],
            obecnieRozwiniety: false,
        };
        this.formatGodzina = this.formatGodzina.bind(this)
        this.onExpandRow = this.onExpandRow.bind(this)
        this.isExpandableRow = this.isExpandableRow.bind(this)
        this.expandComponent = this.expandComponent.bind(this)
        this.expandColumnComponent = this.expandColumnComponent.bind(this)
        this.pobierzPrzystankiWKursie = this.pobierzPrzystankiWKursie.bind(this)
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.czyBylaZmianaSzukania)) {
            this.setState({obecnieRozwiniety: false})
            this.props.wylaczZmianeSzukania()
        }
    }

    formatGodzina(cell, row) {
        let godz = DataFormat.formatNormalTime(cell)
        return godz
    }

    expandComponent(row) {
        return (
            <div style={{borderBottom: '3px solid #5fb146'}}>
                <h5>Przystanki na trasie<span style={{marginLeft: '5px'}} className={'label label-ebus-primary'}>{row.nazTr}</span></h5>
                <PokazRozkladPrzystankiTable data={this.state.expanded_content}/>
            </div>
        )
    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<Button><i className={'fa fa-eye-slash'}></i> Ukryj przystanki</Button>)
                    :
                    (<Button><i className={'fa fa-eye'}></i> Pokaż przystanki</Button>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        if (Boolean(this.state.obecnieRozwiniety)) {
            return row.idKu === this.state.obecnieRozwiniety;
        }
        else {
            return true
        }
    }

    onExpandRow(cell, switchToExpand) {
        if (switchToExpand) {
            this.setState({obecnieRozwiniety: cell})
            this.pobierzPrzystankiWKursie(cell)
        }
        else {
            this.setState({expanded_content: [], obecnieRozwiniety: false})
        }
    }

    pobierzPrzystankiWKursie(idKursu) {
            let params =  'idKu='+idKursu
            RozkladService.getSzukajRozklad(params).then(function (response) {
                this.setState({expanded_content: response.data.content})
            }.bind(this))
    }

    render() {

        const options = {
            sizePerPage: 30,
            sizePerPageList: [10, 15, 30, 50, 100],
            onExpand: this.onExpandRow,
            expandBy: 'column',
            noDataText: 'Brak pasujących rekordów',
        };

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination={this.props.pagination}
                                hover
                                expandableRow={this.isExpandableRow}
                                expandComponent={this.expandComponent}
                                expandColumnOptions={{
                                    expandColumnVisible: true,
                                    expandColumnComponent: this.expandColumnComponent,
                                    columnWidth: 300,
                                }}
                >
                    <TableHeaderColumn dataField='idKu' isKey
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       expandable={false}
                    >Numer kursu</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTr'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       expandable={false}
                    >Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazPr'
                                       thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       expandable={false}
                    >Przystanek</TableHeaderColumn>
                    <TableHeaderColumn dataField='godz'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatGodzina}
                                       expandable={false}
                    >Godzina odjazdu</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/rozklad/components/UrzadRozkladTable.js